var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pt-8",
    staticStyle: {
      "max-width": "1785px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-card-title', {
    staticClass: "primary white--text pa-3"
  }, [_vm.nothingToShow ? _c('div', {
    staticClass: "pa-2"
  }) : _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "background-color": "primary",
      "dark": "",
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.schedules, function (s) {
    return _c('v-tab', {
      key: s.xid
    }, [_vm._v(_vm._s(s.title))]);
  }), 1), _c('v-switch', {
    staticClass: "mt-2",
    attrs: {
      "label": "Show blocked tasks",
      "dark": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.showWaiting,
      callback: function callback($$v) {
        _vm.showWaiting = $$v;
      },
      expression: "showWaiting"
    }
  })], 1)])], 1), _vm.nothingToShow ? _c('p', {
    staticClass: "ma-4 pt-2 text-body-2"
  }, [_vm._v(" There are no schedules currently assigned to you. ")]) : _vm._e(), _c('v-tabs-items', {
    staticClass: "transparent",
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.schedules, function (s) {
    return _c('v-tab-item', {
      key: s.xid,
      staticClass: "transparent",
      attrs: {
        "transition": false
      }
    }, [_c('ScheduleListing', {
      attrs: {
        "scheduleId": s.xid,
        "availability": _vm.showWaiting ? 'all' : 'available'
      }
    })], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }